const newEquipmentType = {
  snackbar: "Ihr Update ist fertig",
  name: "Name des Gerätetyps",
  save: "speichern",
  cancel: "Stornieren",
  area: "Ausstattungsart",
  formTitle: "Ausstattungsart",
  isPump: "Ist eine Pumpe?",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen"
};
export default newEquipmentType;
